import styled from '@emotion/styled';
import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { BECOME_A_PARTNER, GLOBAL_IMPORTS, IMPORT_FROM_CHINA, TRACK } from '../../routes/routeConstants';

const NewFooter: FC = () => {
  return (
    <FooterContainer>
      <FooterTop>
        <LogoSection>
          <img src='/logo.svg' alt='Confidence Mason Limited Logo' />
          <h1>CONFIDENCE <br />MASON LIMITED</h1>
        </LogoSection>
        <LinksSection>
          <LinkGroup>
            <h4>Company</h4>
            <StyledNavLink to='#'>Terms of Service</StyledNavLink>
            <StyledNavLink to='#'>Privacy Policy</StyledNavLink>

          </LinkGroup>
          <LinkGroup>
            <h4>Services</h4>
            <StyledNavLink to={`/${TRACK}`}>Tracking</StyledNavLink>
            <StyledNavLink to={`/${BECOME_A_PARTNER}`}>Partners</StyledNavLink>
            <StyledNavLink to={`/${IMPORT_FROM_CHINA}`}>Chinese Brands</StyledNavLink>
            <StyledNavLink to={`/${GLOBAL_IMPORTS}`}>Global Brands</StyledNavLink>
          </LinkGroup>
        </LinksSection>
      </FooterTop>
      <FooterBottom>
        &copy; {new Date().getFullYear()} Confidence Mason Limited, Inc. All rights reserved.
      </FooterBottom>
    </FooterContainer>
  );
};

export default NewFooter;



const FooterContainer = styled.footer`
  background-color: #062a08;
  color: rgba(255, 255, 255, 0.8);
  padding: 3rem 4rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;

    @media (max-width: 600px) {
  padding: 2rem 24px;
  }
`;

const FooterTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 600px) {
    width: 100%;
    flex-direction: column;
    gap: 2rem;
  }
`;

const LogoSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;

  img {
    width: 100px;
    height: auto;

   @media (max-width: 600px) {
    width: 85px;
  }
  }

  h1 {
    font-size: 2.15rem;
    line-height: 2.25rem;
    color: #FFFFFF;

    @media (max-width: 600px) {
    font-size: 1.4rem;
    line-height: 1.8rem;
  }
  }
`;

const LinksSection = styled.div`
  display: flex;
  gap: 4rem;
  padding-right: 5rem;

    @media (max-width: 882px) {
    padding-right: 0;
  }
`;

const LinkGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  h4 {
    font-weight: 700;
    color: #FFFFFF;
    font-size: 14px;
    margin-bottom: 0.25rem;
  }
`;

const StyledNavLink = styled(NavLink)`
  text-decoration: none;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 400;

  &.active {
    color: #FFFFFF;
  }

  &:hover {
    color: rgba(255, 255, 255, 1);
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: 1rem;
  font-size: 0.75rem;
  color: #FFFFFF;
  text-align: center;
`;
